import { getDefaultEnergyLabel } from '@hb/modules/global/global.constants';

import { Pipe, PipeTransform } from '@angular/core';

import { PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';

@Pipe({
    name: 'energyLabelPipe',
    standalone: true
})
export class EnergyLabelPipe implements PipeTransform {
    transform(propertyType: PropertyType): string {
        return this.getContentKey(getDefaultEnergyLabel(propertyType));
    }

    private getContentKey(energyLabel: string): string {
        return `global.energy-label-${energyLabel}.option`;
    }
}
